import { useEffect } from 'react';
import { isArrowKey } from 'packages/pages/utils';
import { useIsModalOpen } from 'packages/hooks/useIsModalOpen';

const useArrowScrollBlocker = () => {
    const isModalOpen = useIsModalOpen();

    useEffect(() => {
        const onKeyDown = (event: any) => {
            if (
                isArrowKey(event) &&
                event.target?.scrollHeight &&
                event.target.nodeName !== 'INPUT' &&
                // UCV uses shadowDOM, so the root element is always a div but with shadowRoot
                !event.target.shadowRoot &&
                !isModalOpen
            ) {
                event.preventDefault();
            }
        };

        document.addEventListener('keydown', onKeyDown);

        return () => {
            document.removeEventListener('keydown', onKeyDown);
        };
    }, []);
};

export default useArrowScrollBlocker;
